import { render, staticRenderFns } from "./RandomRoomsComponent.vue?vue&type=template&id=3bb0cf46"
import script from "./RandomRoomsComponent.vue?vue&type=script&lang=js"
export * from "./RandomRoomsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports